export interface ProductFeatureConfig {
  basePath: string;
  accountId: string;
  /**
   * Base path for the V2 companies API (`{companiesBasePath}/v2/companies/{accountId}`).
   * The service reads `contractType` from the company payload to set `accountWorld`. The company
   * fetch is non-fatal: a failure leaves `accountWorld = UNKNOWN` and does not reject
   * `initialize()`. Only the platform shell (carrier bootstrapper) constructs this config —
   * plugins never call `initialize()`.
   */
  companiesBasePath: string;
  /**
   * Upper bound in milliseconds for the non-fatal company fetch. The fetch only
   * patches `accountWorld`, so a stalled response must never hold `getFeatures()`
   * open. When the bound elapses, `accountWorld` stays `UNKNOWN` and
   * `getFeatures()` resolves.
   *
   * Optional. Omit it to keep the service default of 10000 ms. Raise it per
   * stage from the carrier bootstrapper when a slower backend needs longer.
   */
  companyFetchTimeoutMs?: number;
}
